import AudioAttachmentsContainer from './AudioAttachmentsContainer';

export default AudioAttachmentsContainer;
